import { render, staticRenderFns } from "./add.vue?vue&type=template&id=ed4bd84a&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed4bd84a')) {
      api.createRecord('ed4bd84a', component.options)
    } else {
      api.reload('ed4bd84a', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=ed4bd84a&", function () {
      api.rerender('ed4bd84a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/baseInformation/WuyeZiyuanManager/advertising/add.vue"
export default component.exports